import { useEffect, useState } from 'react';
import axios from '../api';

export default function AdminDownloadsStats() {
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [byFile, setByFile] = useState([]);
  const [byUser, setByUser] = useState([]);
  const [byDay, setByDay] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get('/uploads/admin/categories').then(res => setCategories(res.data.items || []));
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams();
      if (from) qs.set('from', from);
      if (to) qs.set('to', to);
      if (categoryId) qs.set('categoryId', categoryId);
      const [f, u, d] = await Promise.all([
        axios.get(`/uploads/admin/stats/downloads/by-file?${qs.toString()}`),
        axios.get(`/uploads/admin/stats/downloads/by-user?${qs.toString()}`),
        axios.get(`/uploads/admin/stats/downloads/by-day?${qs.toString()}`),
      ]);
      setByFile(f.data.items || []);
      setByUser(u.data.items || []);
      setByDay(d.data.items || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStats(); }, []);

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Download-Statistik</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Auswertungen zu Downloads, gefiltert nach Zeitraum und Kategorie.</p>
      </section>
      <section style={{ width:'100%', maxWidth:1100, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr auto', gap:8, alignItems:'end', marginBottom:12 }}>
          <label>
            <div style={{ fontSize:12, color:'#bbb' }}>Von</div>
            <input type="date" value={from} onChange={e=>setFrom(e.target.value)} />
          </label>
          <label>
            <div style={{ fontSize:12, color:'#bbb' }}>Bis</div>
            <input type="date" value={to} onChange={e=>setTo(e.target.value)} />
          </label>
          <label>
            <div style={{ fontSize:12, color:'#bbb' }}>Kategorie</div>
            <select value={categoryId} onChange={e=>setCategoryId(e.target.value)}>
              <option value="">— alle —</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
          <button onClick={fetchStats} disabled={loading}>Aktualisieren</button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
          <div>
            <h3 style={{ margin:'8px 0' }}>Top Dateien</h3>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign:'left', padding:'6px 8px' }}>Datei</th>
                  <th style={{ textAlign:'right', padding:'6px 8px' }}>Downloads</th>
                </tr>
              </thead>
              <tbody>
                {byFile.map((r, i) => (
                  <tr key={r.fileId}>
                    <td style={{ padding:'6px 8px' }}>{r.title || `#${r.fileId}`}</td>
                    <td style={{ padding:'6px 8px', textAlign:'right' }}>{r.downloads}</td>
                  </tr>
                ))}
                {byFile.length === 0 && (
                  <tr><td colSpan={2} style={{ color:'#aaa', padding:'6px 8px' }}>Keine Daten</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <div>
            <h3 style={{ margin:'8px 0' }}>Top Nutzer</h3>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign:'left', padding:'6px 8px' }}>Nutzer</th>
                  <th style={{ textAlign:'right', padding:'6px 8px' }}>Downloads</th>
                </tr>
              </thead>
              <tbody>
                {byUser.map((r) => (
                  <tr key={r.userId || 'anon'}>
                    <td style={{ padding:'6px 8px' }}>{r.displayName || r.username || (r.userId ? `#${r.userId}` : '—')}</td>
                    <td style={{ padding:'6px 8px', textAlign:'right' }}>{r.downloads}</td>
                  </tr>
                ))}
                {byUser.length === 0 && (
                  <tr><td colSpan={2} style={{ color:'#aaa', padding:'6px 8px' }}>Keine Daten</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ marginTop:16 }}>
          <h3 style={{ margin:'8px 0' }}>Verlauf (pro Tag)</h3>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign:'left', padding:'6px 8px' }}>Tag</th>
                <th style={{ textAlign:'right', padding:'6px 8px' }}>Downloads</th>
              </tr>
            </thead>
            <tbody>
              {byDay.map((r) => (
                <tr key={String(r.day)}>
                  <td style={{ padding:'6px 8px' }}>{String(r.day).substring(0,10)}</td>
                  <td style={{ padding:'6px 8px', textAlign:'right' }}>{r.downloads}</td>
                </tr>
              ))}
              {byDay.length === 0 && (
                <tr><td colSpan={2} style={{ color:'#aaa', padding:'6px 8px' }}>Keine Daten</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
